/** Assessment — overview + pre-G1 sub-pages. */

export const ASSESSMENT_FLOWS = [
  { id: "overview", label: "Overview" },
  { id: "readiness", label: "Evidence quality" },
  { id: "pain", label: "Pain" },
  { id: "why", label: "WHY" },
  { id: "g1", label: "G1 review" },
  { id: "domain", label: "One domain" },
  { id: "lenses", label: "7C / 7S" },
  { id: "passport", label: "Profile" },
];

export const ASSESSMENT_DRILL = ASSESSMENT_FLOWS.filter((f) => f.id !== "overview");

export const ASSESSMENT_FOCUS_DETAIL = {
  overview: "Evidence quality, WHY and G1 readiness — one step at a time.",
  readiness: "Coverage, states and authorization eligibility.",
  pain: "Documented pains before WHY and 7R.",
  why: "Business intent and enterprise trace chain.",
  g1: "G1 decision fork and legitimate defer outcomes.",
  domain: "Single input domain facts with provenance.",
  lenses: "7C / 7S assessment trace.",
  passport: "Progressive application profile enrichment.",
};

export function resolveAssessmentFocus(explicit, step) {
  if (explicit) return explicit;
  if (step === "why") return "why";
  if (step === "assess") return "readiness";
  return "overview";
}
